import { Map } from 'immutable';
import actions from './actions';

const initState = new Map({
  success: false ,
  msg:'',
  result: [],
  exportresult: [],
  listresult:[],
  listsuccess:false,
  total_count: 0,
});


export default function catTreeReducer(state = initState, action) {
  // console.log('action',action);
   switch (action.type) {
   case actions.CAT_TREE_LIST:
    return state.set('info', action.payload.info);
   case actions.CAT_TREE_LIST_RESULT:
   return state
     .set('exportresult', action.result)
     .set('result', action.result)
     .set('success', action.success)
     .set('total_count', action.total_count)
     default:
       return state;
   }
   //return state;
 }